var cifAt = ["301 201", "<g fill='none'><path fill='#ED2939' d='M.5.5h300v200H.5z'/><path fill='#FFF' d='M.5 67.166h300v66.667H.5z'/></g>"];

export { cifAt };

